import { Handle, HandleType, Position } from 'reactflow';

type Props = {
  type: HandleType;
  position: Position;
  isValid?: boolean;
  isConnectable: boolean;
};
export const EdgeHandle = ({ type, position, isConnectable, isValid = true }: Props) => {
  return (
    <Handle
      type={type}
      position={position}
      isConnectable={isConnectable}
      style={{
        background: '#8BACFF',
        width: '12px',
        height: '12px',
      }}
    >
      {!isValid && <div className="node-handle-pulse border-[#8BACFF] dark:border-white"></div>}
    </Handle>
  );
};
